// src/routes/_org.tsx
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { OrgPortalShell } from '@/components/layouts/OrgPortalShell';
import { AUTH_ROUTES } from '@/lib/constants';
import { filterStateSchema } from '@/features/org-analytics/schemas/shared';
import { useAuthStore } from '@/stores/authStore';

export const Route = createFileRoute('/_org')({
  validateSearch: filterStateSchema,
  beforeLoad: () => {
    const { isAuthenticated, user } = useAuthStore.getState();
    if (!isAuthenticated || !user) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error, @typescript-eslint/no-unnecessary-type-assertion -- 'as never' is load-bearing for pnpm build: tsc -b requires a search shape for /login here; the lint-side program flags it as redundant (false positive)
      throw redirect({ to: AUTH_ROUTES.STAFF_LOGIN as never });
    }
    if (user.role !== 'org_user') {
      // Other roles get sent through `/app` which routes them correctly.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/app' });
    }
  },
  component: OrgLayout,
  staticData: { surface: 'Organization Portal' },
});

function OrgLayout() {
  return (
    <OrgPortalShell>
      <Outlet />
    </OrgPortalShell>
  );
}
